import React from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import { Box, Dialog, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'

import { MoySkladProductPriceRow } from './MoySkladProductPriceRow'

import { MoySkladProductPriceModel } from '../server/mpsklad_core/Models/MoySkladProductPriceModel'

export type MoySkladProductPriceDialogProps = {
  prices: MoySkladProductPriceModel[] | null
  open: boolean
  onClose: () => void
};

export const MoySkladProductPriceDialog =
  observer(
    ({prices, open, onClose}: MoySkladProductPriceDialogProps) => {
      const classes = useStyles()

      if (!open) {
        return null
      }

      return (
        <Dialog open onClose={onClose} maxWidth={false}>
          {
            prices?.length
            ? <TableContainer>
              <Table>
                <TableHead>
                  <TableRow className={clsx('table_head_row', classes.head)}>
                    <TableCell className={classes.cell}>Тип</TableCell>

                    <TableCell className={classes.cell}>Значение</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {prices.map(price =>
                    <MoySkladProductPriceRow key={price.externalId} price={price}/>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            : <Box padding={3} textAlign="center">
              Нет данных о ценах.
            </Box>
          }
        </Dialog>
      )
    })

const useStyles = makeStyles(
  ({palette}) => ({
    head: {
      background: palette.mpSkladSecondary.blue
    },
    cell: {
      border: `2px solid ${palette.mpSkladPrimary.white}`,
      padding: '8px 10px',
      fontSize: '12px',
      height: 30
    }
  }))